import { render, staticRenderFns } from "./InHospitalManager.vue?vue&type=template&id=7bc05f12&"
import script from "./InHospitalManager.vue?vue&type=script&lang=js&"
export * from "./InHospitalManager.vue?vue&type=script&lang=js&"
import style0 from "./InHospitalManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports